import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { handlePoster } from '../datas/poster'
export default {
  getPosterList (ctx, data) {
    return fetch.getPosterList(data).then(res => {
      res.data.forEach(item => {
        handlePoster(item)
      })
      return getTotalNumber(res)
    })
  },
  createPoster (ctx, data) {
    return fetch.createPoster(data).then(res => {
      return res.data
    })
  },
  updatePoster (ctx, data) {
    return fetch.updatePoster(data).then(res => {
      return res.data
    })
  },
  getPosterDetail (ctx, id) {
    return fetch.getPosterDetail(id).then(res => {
      handlePoster(res.data)
      return res.data
    })
  },
  deletePoster (ctx, id) {
    return fetch.deletePoster(id).then(res => {
      return res.data
    })
  },
  posterOperation (ctx, data) {
    return fetch.posterOperation(data).then(res => {
      return res.data
    })
  },
  searchPoster (ctx, data) {
    return fetch.searchPoster(data).then(res => {
      res.data.forEach(item => {
        handlePoster(item)
      })
      return getTotalNumber(res)
    })
  }
}
